'use client';

import { c as _c } from "react/compiler-runtime";
import './child-bio.scss';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ChildAvailabilityItem, ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { ChildBioDetails } from '../../../molecules/child-bio-details/child-bio-details.tsx';
import { ChildBioImage } from '../../../molecules/child-bio-image/child-bio-image.tsx';
import { ChildBioDisplayVariants } from '../../../utils/child-bio.ts';
export const ChildBioDisplay: React.FC<{
  details: ChildDetails;
  availability: ChildAvailabilityItem;
  seoLevel?: number;
  variant: ChildBioDisplayVariants;
}> = t0 => {
  const $ = _c(22);
  const {
    seoLevel: t1,
    details,
    availability,
    variant
  } = t0;
  const seoLevel = t1 === undefined ? 1 : t1;
  const isSticky = variant === ChildBioDisplayVariants.STICKY;
  let t2;
  if ($[0] !== isSticky) {
    t2 = cn("ChildBio__flex flex", {
      "ChildBio__flex--sticky": isSticky
    });
    $[0] = isSticky;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isSticky ? "1" : undefined;
  const t4 = isSticky ? "3-4" : undefined;
  let t5;
  if ($[2] !== availability || $[3] !== details || $[4] !== isSticky || $[5] !== t3 || $[6] !== t4) {
    t5 = <div className="ChildBio__media"><ChildBioImage details={details} availability={availability} fullWidth={isSticky} aspectRatio={t3} aspectRatioSm={t4} /></div>;
    $[2] = availability;
    $[3] = details;
    $[4] = isSticky;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isSticky) {
    t6 = cn("ChildBio__content", {
      "px-comfy-sm sm:px-none": isSticky
    });
    $[8] = isSticky;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== availability || $[11] !== details || $[12] !== isSticky || $[13] !== seoLevel) {
    t7 = <ChildBioDetails seoLevel={seoLevel} details={details} availability={availability} isSticky={isSticky} />;
    $[10] = availability;
    $[11] = details;
    $[12] = isSticky;
    $[13] = seoLevel;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <div className={t6}>{t7}</div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t2 || $[19] !== t5 || $[20] !== t8) {
    t9 = <div className={t2}>{t5}{t8}</div>;
    $[18] = t2;
    $[19] = t5;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};